var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"svg-path":_vm.svgPath,"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description,"primary-button-link":_vm.$options.DOC_PATH_SECURITY_CONFIGURATION,"primary-button-text":_vm.$options.i18n.primaryButtonText}})
}
var staticRenderFns = []

export { render, staticRenderFns }